import { useQuery as y, useQueryClient as g, useMutation as p } from "@tanstack/react-query";
import i from "./course-hearings.api.js";
import { teachurKeys as a } from "../../constants/teachurKeys.js";
const q = (e, r) => y({
  queryKey: a.courseHearings.list(e),
  queryFn: async () => (await i.getCourseHearings(e)).data,
  ...r
}), C = (e, r) => y({
  queryKey: a.courseHearings.detail(e),
  queryFn: async () => (await i.getCourseHearing(e)).data,
  ...r
}), w = (e) => {
  const r = g(), { onSuccess: s, onError: o, ...c } = e ?? {};
  return p({
    mutationFn: async ({ submissionId: n, data: t }) => (await i.reviewSubmission(n, t)).data,
    onSuccess: (n, t, u) => {
      r.invalidateQueries({ queryKey: a.courseHearings.all }), s == null || s(n, t, u);
    },
    onError: (n, t, u) => {
      o == null || o(n, t, u);
    },
    ...c
  });
};
export {
  C as useGetCourseHearingQuery,
  q as useGetCourseHearingsQuery,
  w as useReviewHearingSubmissionMutation
};
